import Button from './Button';
import React from 'react';
import SecondaryButton, { DEFAULT_MARGIN_BOTTOM_BUTTON } from './SecondaryButton';
import { COLORS, NEUTRAL_TEXT0 } from '../../config/designSystem/Colors';
import { View } from 'react-native';
import { isNil, isUndefined } from 'lodash';
import { isWeb } from '../../config/designSystem/Layout';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';

export const DEFAULT_SECOND_BUTTON_COLOR = NEUTRAL_TEXT0;

interface TwoButtonsProps {
    onPressTop: () => void;
    onPressBelow: () => void;
    labelTop: string
    labelBelow: string;
    backgroundColorTop?: string | null;
    textColorTop?: string | null;
    backgroundColorBelow?: string | null;
    textColorBelow?: string | null;
    smallText?: boolean;
    disallowTop?: boolean;
    disallowBelow?: boolean;
    marginBottom?: number;
    marginBetweenButtons?: number;
    height?: number;
    width?:number;
    marginTop?:null
}

export const TwoButtonsVertical = ({ onPressTop, onPressBelow, marginBottom,marginTop, height,  width, smallText, labelTop, labelBelow, marginBetweenButtons,disallowBelow, disallowTop, backgroundColorTop, textColorTop, backgroundColorBelow, textColorBelow }: TwoButtonsProps) => {

  const BACKGROUND_TOP = backgroundColorTop ? backgroundColorTop : COLORS.brand[500];
  const BACKGROUND_BELOW = backgroundColorBelow ? backgroundColorBelow : DEFAULT_SECOND_BUTTON_COLOR;


  const TEXT_TOP = textColorTop ? textColorTop : NEUTRAL_TEXT0;
  const TEXT_BELOW = textColorBelow ? textColorBelow : COLORS.brand[500];


  const { width: widthWindow, height: heightWindow } = useAvailableDimensions();
  const WIDTH = Math.max(100, Math.min(800, widthWindow)) ;
  const SMALL_TEXT = !!smallText && smallText;

  const WIDTH_BUTTON = !isNil(width)?width:(isWeb ? 0.5 * WIDTH : 0.9*WIDTH);
  const MARGIN_BOTTOM = !isUndefined(marginBottom) ? marginBottom : DEFAULT_MARGIN_BOTTOM_BUTTON;
  const MARGIN_BETWEEN_BUTTONS = !isNil(marginBetweenButtons)?marginBetweenButtons:DEFAULT_MARGIN_BOTTOM_BUTTON;
  const MARGIN_TOP= !isNil(marginTop)?marginTop:0;
  const HEIGHT = !isNil(height)?height:100;

  const HEIGHT_BUTTON = (HEIGHT - MARGIN_BETWEEN_BUTTONS - MARGIN_BOTTOM - MARGIN_TOP) / 2;
  const PADDING_BIG_BUTTON = disallowBelow?0:0; // no change for now
  const HEIGHT_FIRST_BUTTON = disallowBelow?(HEIGHT_BUTTON+2*PADDING_BIG_BUTTON):HEIGHT_BUTTON;

  return (<View style={[isWeb &&
    { marginTop: heightWindow * 0.1,maxWidth: WIDTH , width: WIDTH_BUTTON},
  { justifyContent: 'flex-end', width:'90%',maxWidth: WIDTH }]}>
    {!disallowTop && (<View >
      <Button label={labelTop}
        onPress={onPressTop}
        backgroundColor={BACKGROUND_TOP}
        color={TEXT_TOP}
        smallText={SMALL_TEXT}
        width={WIDTH_BUTTON}
        marginBottom={MARGIN_BETWEEN_BUTTONS}
        marginTop={MARGIN_TOP}
        height={HEIGHT_FIRST_BUTTON}
        paddingVertical={PADDING_BIG_BUTTON}
      />
    </View>)}
    <View style={{height:HEIGHT_BUTTON}}>
      {!disallowBelow && (
        <SecondaryButton label={labelBelow}
          onPress={onPressBelow}
          color={TEXT_BELOW}
          backgroundColor={BACKGROUND_BELOW}
          smallText={SMALL_TEXT}
          width={WIDTH_BUTTON}
          marginBottom={MARGIN_BOTTOM}
          marginTop={0}
          height={HEIGHT_BUTTON}
          paddingVertical={0}
        />
      )}
    </View>
  </View>);
};